// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"13f54d8f","455":"8b6709b4","977":"668d0fc7"}[chunkId] + ".chunk.js";
};